import { useCallback, memo } from 'react'
import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import CustomButton from 'components/Shared/Button/index'
import CustomDialog from 'components/Shared/Dialog'
import { useAppSelector } from 'redux/Hook'
import 'components/Reporting/Overview/FilterBuilder/FilterSet/DeleteFilter/Delete.scss'

const DeleteFilterSet = ({
  testProps = false,
  handleDeleteSelection,
  onCloseModal,
  deleteModalVisibility,
}: any) => {
  const { t } = useTranslation()

  const {
    filterBuilder: {
      savedFilter: { originalFilterName = '', filterId = '' } = {},
    } = {},
    features: {
      features: { overview_dashboard_sharing: { enabled = false } = {} } = {},
    } = {},
  }: any = useAppSelector((state) => state)

  const onDelete = useCallback(async () => {
    const result = await handleDeleteSelection(filterId)

    if (result) {
      onCloseModal('delete')
    }
  }, [filterId])

  const DeleteModalContent = () => {
    return (
      <div className="delete-filter-content">
        <Typography mt={2}>
          <p>
            {t('reporting.filterSet.aboutToDelete')}
            <strong>
              {' '}
              {`${originalFilterName?.length ? originalFilterName + '.' : ''}`}
            </strong>
          </p>
          {enabled && (
            <p
              dangerouslySetInnerHTML={{
                __html: t('reporting.filterSet.actionDelete'),
              }}
            />
          )}
          <p>{t('reporting.filterSet.sureAboutIt')}</p>
        </Typography>
      </div>
    )
  }
  const customDialogProps = {
    title: t('reporting.filterSet.deleteAFilterSet'),
    showCloseBtn: true,
    enableActionButtons: true,
    enableBackdropClick: true,
    content: <DeleteModalContent />,
    onCloseModal: () => onCloseModal('delete'),
    isModalOpen: deleteModalVisibility,
    primaryBtn: (
      <CustomButton
        title={t('common.yes')}
        btnVariant="contained"
        onClick={onDelete}
      />
    ),
    secondaryBtn: (
      <CustomButton
        title={t('common.no')}
        disabled={false}
        onClick={() => onCloseModal('delete')}
      />
    ),
    ...(testProps && {
      testProps: {
        disablePortal: true,
        hideBackdrop: true,
        TransitionComponent: ({ children }: any) => children,
      },
    }),
  }

  return <CustomDialog {...customDialogProps} />
}

export default memo(DeleteFilterSet)
